import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const SelectField = ({ options, value, onChange, label, prefix, placeholder }) => {
  const handleChange = (e) => {
    const selectedValue = e.target.value;
    onChange(selectedValue === '' ? '' : selectedValue);
  };

  const selectedOption = options?.find((opt) => String(opt.value) === String(value));
  const hasValue = value && selectedOption && value !== '';
  const displayText = hasValue ? selectedOption.name : (placeholder || label || 'Все');

  return (
    <div className={'px-2 h-[38px] flex gap-x-2 items-center relative border border-gray-300 rounded-lg bg-white'}>
      {prefix && <div className="flex items-center">{prefix}</div>}
      <div className="flex-1 flex items-center min-w-0 relative">
        <select
          value={value || ''}
          onChange={handleChange}
          className="absolute inset-0 w-full h-full bg-transparent border-none outline-none cursor-pointer appearance-none opacity-0 z-10"
        >
          {options && options.length > 0 ? (
            options.map((option) => (
              <option key={option.value || 'all'} value={option.value}>
                {option.name}
              </option>
            ))
          ) : (
            <option value="">{placeholder || label || 'Все'}</option>
          )}
        </select>
        <div className="flex items-center gap-x-2 flex-1 min-w-0 text-sm">
          <span className={`truncate flex-1 ${hasValue ? 'text-gray-800' : 'text-gray-400'}`}>
            {displayText}
          </span>
          <KeyboardArrowDownIcon className="text-gray-500 flex-shrink-0 ml-auto" fontSize="small" />
        </div>
      </div>
    </div>
  );
};

export default SelectField;
